import React from 'react';
import { MainStore } from '../../../stores/MainStore';

export enum PIPIconType {
    Legal = 0,
    Marketing = 1,
}

export interface PIPIcon {
    type: PIPIconType;
    imageUrl: string;
    imageAltTag: string;
    index: number;
}

export type PictureInPictureProps = {
    store: MainStore;
    children: React.ReactNode;
    // Adjust icons position based on other elements on the image
    layoutAdjustments?: PictureInPictureLayoutAdjustments
}

export type PictureInPictureLayoutAdjustments = {
    // Adjust icons position based on other elements on the image
    hasPlayButton?: boolean;
}


